module.exports = __webpack_public_path__ + "img/Lifesize-Kaptivo.57e221f1.png";